import { api } from './api';

export interface ReporteVentas {
  ventas: Array<{
    periodo: string;
    total: number;
    ordenes: number;
    sucursal?: string;
  }>;
  total: number;
  totalOrdenes: number;
  fechaDesde: string;
  fechaHasta: string;
}

export interface ReporteProductos {
  productos: Array<{
    productoId: number;
    nombre: string;
    sku?: string;
    cantidad: number;
    total: number;
    ordenes: number;
  }>;
}

export interface ReporteArqueos {
  sesiones: Array<any>;
  resumen: {
    totalSesiones: number;
    totalVentas: number;
    totalEfectivo: number;
    totalTarjeta: number;
    totalDiferencias: number;
  };
}

export interface ReporteInventario {
  productos: Array<{
    productoId: number;
    nombre: string;
    sku?: string;
    entradas: number;
    salidas: number;
    movimientos: Array<{
      tipo: string;
      cantidad: number;
      fecha: string;
    }>;
  }>;
}

export interface Dashboard {
  ventasHoy: number;
  ordenesHoy: number;
  sesionesAbiertas: number;
}

export const reporteService = {
  getDashboard: async (): Promise<{ data: Dashboard }> => {
    const response = await api.get<{ data: Dashboard }>('/reportes/dashboard');
    return response.data;
  },

  getVentas: async (
    fechaDesde: string,
    fechaHasta: string,
    sucursalId?: number,
    agruparPor: 'hora' | 'dia' | 'mes' | 'sucursal' = 'dia'
  ): Promise<{ data: ReporteVentas }> => {
    const params = new URLSearchParams({
      fechaDesde,
      fechaHasta,
      agruparPor
    });
    if (sucursalId) params.append('sucursalId', sucursalId.toString());
    
    const response = await api.get<{ data: ReporteVentas }>(`/reportes/ventas?${params}`);
    return response.data;
  },

  getProductos: async (
    fechaDesde: string,
    fechaHasta: string,
    sucursalId?: number,
    limit = 20
  ): Promise<{ data: ReporteProductos }> => {
    const params = new URLSearchParams({
      fechaDesde,
      fechaHasta,
      limit: limit.toString()
    });
    if (sucursalId) params.append('sucursalId', sucursalId.toString());
    
    const response = await api.get<{ data: ReporteProductos }>(`/reportes/productos?${params}`);
    return response.data;
  },

  getArqueos: async (
    fechaDesde: string,
    fechaHasta: string,
    cajaId?: number
  ): Promise<{ data: ReporteArqueos }> => {
    const params = new URLSearchParams({
      fechaDesde,
      fechaHasta
    });
    if (cajaId) params.append('cajaId', cajaId.toString());
    
    const response = await api.get<{ data: ReporteArqueos }>(`/reportes/arqueos?${params}`);
    return response.data;
  },

  getInventario: async (
    sucursalId?: number,
    lowStock?: boolean
  ): Promise<{ data: ReporteInventario }> => {
    const params = new URLSearchParams();
    if (sucursalId) params.append('sucursalId', sucursalId.toString());
    if (lowStock) params.append('lowStock', 'true');
    
    const response = await api.get<{ data: ReporteInventario }>(`/reportes/inventario?${params}`);
    return response.data;
  }
};

